import html2canvas from "html2canvas"
import { jsPDF as JsPDF } from "jspdf"
import PropTypes from "prop-types"
import React from "react"

const { createContext, useState } = React
const DownloadPageContext = createContext(null)

function DownloadPageContextProvider(props) {
  const [id, setId] = useState("")
  const [loading, setLoading] = useState(false)
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)
  const [isTourOpen, setIsTourOpen] = useState(false)
  const [tourProfile, setTourProfile] = useState(false)
  const [currentTourStep, setCurrentTourStep] = useState(0)
  const [isRouteConfirmModalOpen, setIsRouteConfirmModalOpen] = useState(false)

  const onClickDownload = (id = "") => {
    const input = document.getElementById(id)
    setLoading(true)
    html2canvas(input, { backgroundColor: "#F6FAF1", scale: 2 }).then(
      (canvas) => {
        const imgData = canvas.toDataURL("image/png")
        const pdf = new JsPDF({
          orientation: id === "service-page" ? "portrait" : "landscape",
          unit: "px",
          format: "a4"
        })
        const pdfWidth = pdf.internal.pageSize.getWidth()
        const pdfHeight = pdf.internal.pageSize.getHeight()
        pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHeight)
        pdf.save(`${id}.pdf`)
        setLoading(false)
      }
    )
  }

  return (
    <DownloadPageContext.Provider
      value={{
        onClickDownload,
        id,
        setId,
        loading,
        isDrawerOpen,
        setIsDrawerOpen,
        isTourOpen,
        setIsTourOpen,
        isRouteConfirmModalOpen,
        setIsRouteConfirmModalOpen,
        tourProfile,
        setTourProfile,
        currentTourStep,
        setCurrentTourStep
      }}
    >
      {props.children}
    </DownloadPageContext.Provider>
  )
}

DownloadPageContextProvider.propTypes = {
  children: PropTypes.node
}

export default DownloadPageContext
export { DownloadPageContextProvider }
